module.exports = __webpack_public_path__ + "images/8266573240e0b7af3c7093561ebfec64b4943d543093ddb472cc92d6bf83a162.svg";